import qs from 'qs';
import { request } from '../utils/request';

export const getAllUserMeta = ({ page }) =>
  request({
    url: '/user-metas',
    method: 'GET',
    params: {
      page,
    },
    data: {},
  });

export const searchForAdmin = ({ metaKeys, createDateFrom, createDateTo, email, page, size }) =>
  request({
    url: '/user-metas/searchForAdmin',
    method: 'GET',
    params: {
      metaKeys,
      createDateFrom,
      createDateTo,
      email,
      page,
      size,
    },
    data: {},
  });

export const createMultiUserMeta = (data) =>
  request({
    url: '/user-metas/createMultiUserMeta',
    method: 'POST',
    data,
  });

export const deleteMetasByKey = (key) =>
  request({
    url: '/user-metas/deleteMetasByKey',
    method: 'DELETE',
    params: {
      metaKey: key,
    },
  });

export const getInfoUserMetaOfUsers = ({ userIds, metaKeys }) =>
  request({
    url: '/user-metas/getInfoUserMetaOfUsers',
    method: 'GET',
    params: {
      userIds,
      metaKeys,
    },
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    data: {},
  });

export const getTotalFirstDepositBroker = ({ createdDate, email }) =>
  request({
    url: '/user-metas/getTotalFirstDepositBroker',
    method: 'GET',
    params: { createdDate, email },
  });

export const getFirstDepositAmount = (userId) =>
  request({
    url: '/user-metas/firstDepositAmount',
    method: 'GET',
    params: { userId },
  });

export const getHistoriesChange = ({ id, page, size }) =>
  request({
    url: `/user-metas/${id}/histories`,
    method: 'GET',
    params: { page, size },
  });

export const handleUpdateOpenContactCount = (userId) =>
  request({
    url: '/user-metas/handleUpdateOpenContactCount',
    method: 'POST',
    params: {
      userId: userId
    },
  });

export const searchMetaResume = params =>
  request({
    url: '/user-metas/searchCountOpenResume',
    method: 'GET',
    params,
  });
  
export const handleAdminAddOpenContactCount = (data) =>
  request({
    url: '/user-metas/handleAdminAddOpenContactCount',
    method: 'POST',
    params: data,
  });

export const getLivestreamId = () =>
  request({
    url: '/user-metas/getLivestreamId',
    method: 'GET',
  });